(function(){
  'use strict';
  if (window.__ZK_CART_BRIDGE_V3__) return;
  window.__ZK_CART_BRIDGE_V3__ = true;

  var addLock = false;
  var refreshTimer = null;
  var lastAutoOpenAt = 0;

  function qsAll(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function debounceRefresh(delay){ clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshCounters, delay || 120); }
  function isCartAddUrl(url){ return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/i.test(url); }
  function isCartMutationUrl(url){ return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url); }
  function normalizeUrl(input){ try { return typeof input === 'string' ? input : (input && input.url) || ''; } catch(_) { return ''; } }

  function setCartCount(n){
    n = Number(n || 0);
    qsAll('#cart-icon-bubble .cart-count-bubble, #cart-icon-bubble [data-cart-count]').forEach(function(el){
      var span = el.querySelector('span[aria-hidden="true"], .cart-count') || el;
      if (span) span.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      el.classList.toggle('hidden', n === 0);
    });
    qsAll('[data-zk-cart-count]').forEach(function(el){
      var inner = el.querySelector('.zk-count-text');
      (inner || el).textContent = n;
      el.classList.toggle('is-hidden', n === 0);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: n } }));
  }

  async function getCart(){
    var res = await fetch('/cart.js?ts=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('No se pudo leer /cart.js');
    return res.json();
  }

  async function refreshCounters(){
    try { setCartCount((await getCart()).item_count || 0); } catch(_) {}
  }

  function openCart(){
    try {
      if (window.ZKCart && typeof window.ZKCart.refreshAndShow === 'function') {
        window.ZKCart.refreshAndShow();
        return true;
      }
      if (window.ZKCart && typeof window.ZKCart.open === 'function') {
        window.ZKCart.open();
        debounceRefresh(60);
        return true;
      }
      var root = document.getElementById('zk-cart-root');
      if (root) {
        root.classList.add('zk-open');
        document.documentElement.classList.add('zk-noscroll');
        debounceRefresh(60);
        return true;
      }
    } catch(_) {}
    return false;
  }

  function closeCart(){
    try {
      if (window.ZKCart && typeof window.ZKCart.close === 'function') { window.ZKCart.close(); return true; }
      var root = document.getElementById('zk-cart-root');
      if (root) {
        root.classList.remove('zk-open');
        document.documentElement.classList.remove('zk-noscroll');
        return true;
      }
    } catch(_) {}
    return false;
  }

  window.zkOpenAnyCart = function(ev){ if (ev) { ev.preventDefault(); ev.stopPropagation(); } openCart(); return false; };
  window.zkOpenCart = window.zkOpenCart || openCart;
  window.zkCloseCart = window.zkCloseCart || closeCart;

  async function ajaxAddForm(form){
    if (addLock) return;
    addLock = true;
    var btn = form.querySelector('button[name="add"], button[type="submit"], input[type="submit"]');
    var oldHTML = btn && 'innerHTML' in btn ? btn.innerHTML : '';
    var oldText = btn && 'value' in btn ? btn.value : (btn && 'textContent' in btn ? btn.textContent : '');

    function setButtonLabel(label){
      if (!btn) return;
      var textEl = btn.querySelector('.zk-btn-text, .zk-atc-btn__text, [data-zk-atc-text]');
      if (textEl) { textEl.textContent = label; return; }
      if ('value' in btn && btn.tagName === 'INPUT') { btn.value = label; return; }
      // Último recurso: solo para botones simples sin estructura interna.
      if (!btn.children.length) btn.textContent = label;
    }

    if (btn) { btn.disabled = true; setButtonLabel('Agregando…'); btn.classList.add('is-loading'); }
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) {
        var msg = 'No se pudo agregar al carrito.';
        try { var data = await res.json(); msg = data.description || data.message || msg; } catch(_) {}
        throw new Error(msg);
      }
      await res.json().catch(function(){});
      document.dispatchEvent(new CustomEvent('cart:add'));
      document.dispatchEvent(new CustomEvent('cart:change'));
      debounceRefresh(40);
      openCart();
    } catch (err) {
      console.error('[ZK] Error agregando al carrito:', err);
      alert(err && err.message ? err.message : 'No se pudo agregar al carrito.');
    } finally {
      setTimeout(function(){ addLock = false; }, 600);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (oldHTML && 'innerHTML' in btn) btn.innerHTML = oldHTML;
        else if (oldText) setButtonLabel(oldText);
      }
    }
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action') || '').replace(location.origin, '');
    if (!/\/cart\/add(\.js)?$/i.test(action)) return;
    if (form.hasAttribute('data-zk-native-submit')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ajaxAddForm(form);
  }, true);

  document.addEventListener('click', function(e){
    var openTrigger = e.target.closest('[data-zk-open-cart], [data-zk-cart-open], .zk-nav-item--cart, a[href="/cart"], a[href$="/cart"], #cart-icon-bubble');
    if (openTrigger) { e.preventDefault(); e.stopPropagation(); openCart(); return; }

    var sticky = e.target.closest('[data-zk-sticky-add]');
    if (sticky) {
      e.preventDefault();
      var form = sticky.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (form) ajaxAddForm(form);
    }
  }, true);

  document.addEventListener('zk:cart:added', function(){ debounceRefresh(40); openCart(); });
  document.addEventListener('cart:add', function(){ debounceRefresh(80); });
  document.addEventListener('cart:change', function(){ debounceRefresh(80); });

  if (!window.__ZK_CART_FETCH_BRIDGE__) {
    window.__ZK_CART_FETCH_BRIDGE__ = true;
    var originalFetch = window.fetch;
    window.fetch = function(input, init){
      var url = normalizeUrl(input);
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      return originalFetch.apply(this, arguments).then(function(res){
        if (method !== 'GET' && isCartMutationUrl(url) && res && res.ok) {
          debounceRefresh(80);
          if (isCartAddUrl(url) && Date.now() - lastAutoOpenAt > 500) {
            lastAutoOpenAt = Date.now();
            setTimeout(openCart, 120);
          }
        }
        return res;
      });
    };
  }

  if (!window.__ZK_CART_XHR_BRIDGE__) {
    window.__ZK_CART_XHR_BRIDGE__ = true;
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__zkCartMethod = method;
      this.__zkCartUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      this.addEventListener('loadend', function(){
        try {
          if (this.status >= 200 && this.status < 300 && String(this.__zkCartMethod || 'GET').toUpperCase() !== 'GET' && isCartMutationUrl(this.__zkCartUrl || '')) {
            debounceRefresh(80);
            if (isCartAddUrl(this.__zkCartUrl || '')) setTimeout(openCart, 120);
          }
        } catch(_) {}
      });
      return originalSend.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCounters);
  else refreshCounters();
  window.addEventListener('pageshow', refreshCounters);
})();
